import { SVGProps } from 'react';

export type PinIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
  pinned?: boolean;
};

export const PinnedIcon = ({ color = '#4A4A4A', ...props }: PinIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3334 7.49935V3.33268H14.1667C14.6251 3.33268 15.0001 2.95768 15.0001 2.49935C15.0001 2.04102 14.6251 1.66602 14.1667 1.66602H5.83341C5.37508 1.66602 5.00008 2.04102 5.00008 2.49935C5.00008 2.95768 5.37508 3.33268 5.83341 3.33268H6.66675V7.49935C6.66675 8.88268 5.55008 9.99935 4.16675 9.99935V11.666H9.14175V17.4993L9.97508 18.3327L10.8084 17.4993V11.666H15.8334V9.99935C14.4501 9.99935 13.3334 8.88268 13.3334 7.49935Z"
      fill={color}
    />
  </svg>
);

export const PinIcon = ({ color = '#4A4A4A', ...props }: PinIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6667 3.33268V7.49935C11.6667 8.43268 11.9751 9.29935 12.5001 9.99935H7.50008C8.04175 9.28268 8.33341 8.41602 8.33341 7.49935V3.33268H11.6667ZM14.1667 1.66602H5.83341C5.37508 1.66602 5.00008 2.04102 5.00008 2.49935C5.00008 2.95768 5.37508 3.33268 5.83341 3.33268H6.66675V7.49935C6.66675 8.88268 5.55008 9.99935 4.16675 9.99935V11.666H9.14175V17.4993L9.97508 18.3327L10.8084 17.4993V11.666H15.8334V9.99935C14.4501 9.99935 13.3334 8.88268 13.3334 7.49935V3.33268H14.1667C14.6251 3.33268 15.0001 2.95768 15.0001 2.49935C15.0001 2.04102 14.6251 1.66602 14.1667 1.66602Z"
      fill={color}
    />
  </svg>
);
